import { BranchDetails } from "@/@types/Branches";
import { BranchDetailsResponse } from "../../branches/models/BranchDetailsResponse";

export function mapBranchDetails(branch: BranchDetailsResponse): BranchDetails {
    return {
        name: branch.name,
        responsible: branch.responsible,
        state: branch.state,
        municipality: branch.municipality,
        address: branch.address,
        zipCode: branch.zip_code,
        email: branch.email,
        phone: branch.phone,
        typePhone: branch.type_phone,
        typeBranch: branch.type_branch,
        typeBranchSlug: branch.type_branch_slug,
        image: branch.image,
        order: branch.order,
        latitude: branch.latitude,
        length: branch.length,
        slug: branch.slug,
    }
}